import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { CheckAdminIsAddedPipe } from './check-admin-is-added.pipe';
import { CheckPermissionsPipe } from './check-permissions.pipe';
import { HabilitationCountPipe } from './habilitation-count.pipe';
import { IdNatPSPipe } from './id-nat-ps.pipe';
import { IdNatStructurePipe } from './id-nat-structure.pipe';
import { NomenclaturesPipe } from './nomenclatures.pipe';
import { StructureRaisonIdNatPipe } from './structure-raison-id-nat.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    CheckAdminIsAddedPipe,
    CheckPermissionsPipe,
    HabilitationCountPipe,
    IdNatPSPipe,
    IdNatStructurePipe,
    NomenclaturesPipe,
    StructureRaisonIdNatPipe,
  ],
  exports: [
    CheckAdminIsAddedPipe,
    CheckPermissionsPipe,
    HabilitationCountPipe,
    IdNatPSPipe,
    IdNatStructurePipe,
    NomenclaturesPipe,
    StructureRaisonIdNatPipe,
  ],
  providers: [
    CheckAdminIsAddedPipe,
    CheckPermissionsPipe,
    DatePipe,
    HabilitationCountPipe,
    IdNatPSPipe,
    IdNatStructurePipe,
    NomenclaturesPipe,
    StructureRaisonIdNatPipe,
  ],
})
export class PipesModule { }
